import Vue from "vue";
import Vuex from "vuex";
import warehouse from "./warehouse.js";
import menu from "./menu.js";
import report from "./report.js";
import snackbar from "./snackbar.js";
import restaurantStore from "./restaurant.js"; // RENAMED from restaurant2
import companyMenu from "./companyMenu.js";
import user from "./user.js";
import supplier from "./supplier.js";
import accounts, { accountsPlugin } from "./accounts.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    restaurant: null,
    company: null,
    companies: null,
    isLatin: 0,
    isCyrillic: 0,
    drawer: null,
    notification: [],
    snackbarOld: false,
    isPrinting: false,
    isExcelDownloading: false,
    selectedRestaurant: null,
  },
  mutations: {
    SET_SELECTED_RESTAURANT(state, item) {
      state.selectedRestaurant = item;
      if (item?.id) {
        localStorage.setItem("restorani-selected-restaurant", item.id);
      } else {
        localStorage.removeItem("restorani-selected-restaurant");
      }
    },
    SET_PRINTING(state) {
      state.isPrinting = false;
      setTimeout(() => {
        state.isPrinting = true;
      }, 100);
    },
    SET_EXCEL(state) {
      state.isExcelDownloading = false;
      setTimeout(() => {
        state.isExcelDownloading = true;
      }, 100);
    },
    SAVE_RESTAURANT(state, items) {
      state.restaurant = items;
    },
    SAVE_COMPANY(state, items) {
      state.company = items;
    },
    SAVE_COMPANIES(state, items) {
      state.companies = items;
    },
    // Upisuje polja (npr. settings, alphabet) u sve kopije restorana u memoriji, da stranice ne čitaju staro
    // dok se aplikacija ne osvježi (podešavanja restorana se snimaju bez ponovnog učitavanja stranice).
    SET_RESTAURANT_FIELDS(state, { id, fields }) {
      const patch = (restaurant) => {
        if (restaurant && Number(restaurant.id) === Number(id)) {
          Object.keys(fields).forEach((key) => {
            Vue.set(restaurant, key, JSON.parse(JSON.stringify(fields[key])));
          });
        }
      };
      const patchAll = (list) => (list || []).forEach(patch);
      const patchCompanies = (companies) => (companies || []).forEach((company) => patchAll(company && company.restaurants));
      patch(state.restaurant);
      patch(state.selectedRestaurant);
      if (state.company) {
        patch(state.company.restaurant);
        patchAll(state.company.restaurants);
      }
      patchCompanies(state.companies);
      patchCompanies(state.user && state.user.user && state.user.user.companies);
    },
    SAVE_LANGUAGE(state, item) {
      state.isLatin = item;
    },
    SET_DRAWER(state, item) {
      state.drawer = item;
    },
    INCREASE_NOTIFICATION(state, item) {
      state.notification.push(item);
    },
    SET_NOTIFICATION(state, item) {
      state.notification = item;
    },
    SET_SNACKBAR(state, item) {
      state.snackbarOld = item;
    },
    RESET(state) {
      state.restaurant = null;
      state.company = null;
      state.companies = null;
      state.isLatin = 0;
      state.isCyrillic = 0;
      state.drawer = null;
      state.notification = [];
      state.snackbarOld = false;
      state.isPrinting = false;
      state.isExcelDownloading = false;
      state.selectedRestaurant = null;
      localStorage.removeItem("restorani-selected-restaurant");
    },
  },
  actions: {},
  getters: {
    canAddMeal: (state) => {
      return state.restaurant?.add_meal === 1;
    },
    parentRestaurantName: (state) => {
      return state.restaurant?.parent?.name || "";
    },
    showCloneBtn: (state) => {
      return (
        state.user?.type === "restaurant" &&
        state.restaurant?.parent?.parent_menu === 1
      );
    },
  },
  modules: {
    warehouse,
    report,
    snackbar,
    menu,
    restaurantStore, // RENAMED from restaurant2
    companyMenu,
    user,
    supplier,
    accounts,
  },
  plugins: [accountsPlugin],
});
